/* Journey Lab — 2026-09-08 — back-in-stock capture, variant-change wiring.
 *
 * Dawn's product-info.js does NOT re-render the buy_buttons block on variant change; it copies a
 * fixed set of ids and toggles the submit button. Liquid therefore renders the correct INITIAL
 * state and this file handles every change after it, via the theme's own variantChange pub/sub.
 *
 * Falls back to watching the submit button's disabled attribute if pub/sub is unavailable, so the
 * block still behaves correctly if the theme's script order ever changes.
 */
(function () {
  if (window.__jlAnomaliaNotify) return;          // the block can render more than once per page
  window.__jlAnomaliaNotify = true;

  function boxes() {
    return document.querySelectorAll('[data-jl-notify]');
  }

  // After a successful signup Shopify returns to the product URL with ?customer_posted=true but
  // WITHOUT the ?variant= it was submitted from, so Liquid re-renders on the default (in-stock)
  // size and the block would be hidden — leaving the shopper with no confirmation that anything
  // happened. If the server rendered a success message, show it regardless of selected variant.
  function revealConfirmations() {
    document.querySelectorAll('[data-jl-notify]').forEach(function (box) {
      if (box.querySelector('.jl-notify__success')) box.hidden = false;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealConfirmations);
  } else {
    revealConfirmations();
  }

  function apply(box, variant) {
    if (!box || !variant) return;
    var unavailable = variant.available === false;
    box.hidden = !unavailable;

    // Keep the capture pointed at the size the shopper is actually looking at.
    var tags = box.querySelector('[data-jl-notify-tags]');
    if (tags && variant.id) {
      tags.value = 'notify-me, notify:' + (box.dataset.productHandle || '') + ':' + variant.id;
    }
    var label = box.querySelector('[data-jl-notify-size]');
    if (label && variant.title) label.textContent = variant.title;
  }

  // Preferred path — the theme's own event, which carries the resolved variant object.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      boxes().forEach(function (box) { apply(box, variant); });
    });
    return;
  }

  // Fallback — mirror the submit button, which Dawn always keeps in sync.
  var btn = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!btn) return;
  new MutationObserver(function () {
    var idInput = document.querySelector('input[name="id"].product-variant-id');
    boxes().forEach(function (box) {
      box.hidden = !btn.hasAttribute('disabled');
      var tags = box.querySelector('[data-jl-notify-tags]');
      if (tags && idInput && idInput.value) {
        tags.value = 'notify-me, notify:' + (box.dataset.productHandle || '') + ':' + idInput.value;
      }
    });
  }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
})();
